import React from "react"

import { PrimitiveCard } from "@/primitives/PrimitiveCard"

import { PortletProps } from "@/components/Portlet/protocols"

import useStyles from "@/components/Portlet/styles"

export const Portlet = ({
	children,
	sx,
	...props
}: PortletProps) => {
	const classes = useStyles()

	return (
		<PrimitiveCard
			{...props}
			sx={[classes.card, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}
		>
			{children}
		</PrimitiveCard>
	)
}